interface IProcedures {
    toggleHouse: () => void;
    toggleScenery: () => void;
    takeScreenshot: () => void;
    downloadScreenshot: () => void;
    switchMode: () => void;
    changePlot: (id: string) => void;

}

class Puzzles {
    public procedures: IProcedures | null = null;
    public setProcedures(procedures: any) {
        this.procedures = procedures;
    }
}

const puzzles = new Puzzles();
export default puzzles;
